import type { IconProps } from "../types";

export const LayoutDashboard = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <rect width="7" height="9" x="3" y="3" />
    <rect width="7" height="5" x="14" y="3" />
    <rect width="7" height="9" x="14" y="12" />
    <rect width="7" height="5" x="3" y="16" />
  </svg>
);
